import useHelpers from 'hooks/helpers';
import TrustCard from 'components/Tiles/TrustCard';

const TrustCards = ({ articles, rendering }) => {
  const { anchorId } = useHelpers(rendering);
  return (
    articles.length !== 0 && (
      <div id={anchorId} className="container pb-10">
        <div className={`row d-flex flex-wrap mb-n4 ${articles.length < 4 ? 'w-100' : ''}`}>
          {articles.map((article) => (
            <div key={article.id} className="col-12 col-md-4 col-lg-3 mb-4">
              <TrustCard fields={article} />
            </div>
          ))}
        </div>
      </div>
    )
  );
};

export default TrustCards;
